import enLang from './entries/en_US';
import zhLang from './entries/zh_CN';
import frLang from './entries/fr_FR';
import jaLang from './entries/ja_JP';
import EsLang from './entries/es';

const AppLocale = {
    en: enLang,
    zh: zhLang,
    fr: frLang,
    ja: jaLang,
    es: EsLang
};

export default AppLocale;